module.exports = __webpack_public_path__ + "img/discarded_calender_clock.fe097c49.svg";